module.exports = __webpack_public_path__ + "static/chargers-b191b3c2383b85ee343bb6689820751a.jpg";